import * as constants from './constants'
import init from './init'
import * as i from './insights'
import middleware from './middleware'
import * as utils from './utils'

const insightsInit = init(i)

const insightsMiddleware = middleware(i)

export default i

export {
  constants,
  insightsInit as init,
  insightsMiddleware as middleware,
  utils
}
